import { jsx as D, Fragment as ie } from "react/jsx-runtime";
import Oe, { createElement as X, PureComponent as Ee, useRef as N, useEffect as ve, useMemo as ge, useState as le, useImperativeHandle as We, useCallback as B } from "react";
import { u as we } from "../styled-components.browser.esm-3eb04950.js";
import { Table as Ae } from "antd";
import { g as Ne } from "../_commonjsHelpers-10dfc225.js";
import { l as Y } from "../lodash-fd177a50.js";
import { g as _e } from "../useResizeDetector-71455ac7.js";
var Se = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(a) {
  (function() {
    var e = {}.hasOwnProperty;
    function r() {
      for (var o = "", i = 0; i < arguments.length; i++) {
        var s = arguments[i];
        s && (o = l(o, n(s)));
      }
      return o;
    }
    function n(o) {
      if (typeof o == "string" || typeof o == "number")
        return o;
      if (typeof o != "object")
        return "";
      if (Array.isArray(o))
        return r.apply(null, o);
      if (o.toString !== Object.prototype.toString && !o.toString.toString().includes("[native code]"))
        return o.toString();
      var i = "";
      for (var s in o)
        e.call(o, s) && o[s] && (i = l(i, s));
      return i;
    }
    function l(o, i) {
      return i ? o ? o + " " + i : o + i : o;
    }
    a.exports ? (r.default = r, a.exports = r) : window.classNames = r;
  })();
})(Se);
var ze = Se.exports;
const Le = /* @__PURE__ */ Ne(ze);
function re() {
  return re = Object.assign ? Object.assign.bind() : function(a) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        ({}).hasOwnProperty.call(r, n) && (a[n] = r[n]);
    }
    return a;
  }, re.apply(null, arguments);
}
function se(a) {
  if (a === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return a;
}
function ne(a, e) {
  return ne = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, n) {
    return r.__proto__ = n, r;
  }, ne(a, e);
}
function Fe(a, e) {
  a.prototype = Object.create(e.prototype), a.prototype.constructor = a, ne(a, e);
}
var ce = Number.isNaN || function(e) {
  return typeof e == "number" && e !== e;
};
function ke(a, e) {
  return !!(a === e || ce(a) && ce(e));
}
function Pe(a, e) {
  if (a.length !== e.length)
    return !1;
  for (var r = 0; r < a.length; r++)
    if (!ke(a[r], e[r]))
      return !1;
  return !0;
}
function ee(a, e) {
  e === void 0 && (e = Pe);
  var r, n = [], l, o = !1;
  function i() {
    for (var s = [], f = 0; f < arguments.length; f++)
      s[f] = arguments[f];
    return o && r === this && e(s, n) || (l = a.apply(this, s), o = !0, r = this, n = s), l;
  }
  return i;
}
var De = typeof performance == "object" && typeof performance.now == "function", ue = De ? function() {
  return performance.now();
} : function() {
  return Date.now();
};
function de(a) {
  cancelAnimationFrame(a.id);
}
function He(a, e) {
  var r = ue();
  function n() {
    ue() - r >= e ? a.call(null) : l.id = requestAnimationFrame(n);
  }
  var l = {
    id: requestAnimationFrame(n)
  };
  return l;
}
var te = -1;
function Ue(a) {
  if (a === void 0 && (a = !1), te === -1 || a) {
    var e = document.createElement("div"), r = e.style;
    r.width = "50px", r.height = "50px", r.overflow = "scroll", document.body.appendChild(e), te = e.offsetWidth - e.clientWidth, document.body.removeChild(e);
  }
  return te;
}
var H = null;
function fe(a) {
  if (a === void 0 && (a = !1), H === null || a) {
    var e = document.createElement("div"), r = e.style;
    r.width = "50px", r.height = "50px", r.overflow = "scroll", r.direction = "rtl";
    var n = document.createElement("div"), l = n.style;
    return l.width = "100px", l.height = "100px", e.appendChild(n), document.body.appendChild(e), e.scrollLeft > 0 ? H = "positive-descending" : (e.scrollLeft = 1, e.scrollLeft === 0 ? H = "negative" : H = "positive-ascending"), document.body.removeChild(e), H;
  }
  return H;
}
var Ve = 150, $e = function(e) {
  var r = e.columnIndex;
  e.data;
  var n = e.rowIndex;
  return n + ":" + r;
}, K = null, Z = null, J = null;
process.env.NODE_ENV !== "production" && typeof window < "u" && typeof window.WeakSet < "u" && (K = /* @__PURE__ */ new WeakSet(), Z = /* @__PURE__ */ new WeakSet(), J = /* @__PURE__ */ new WeakSet());
function je(a) {
  var e, r = a.getColumnOffset, n = a.getColumnStartIndexForOffset, l = a.getColumnStopIndexForStartIndex, o = a.getColumnWidth, i = a.getEstimatedTotalHeight, s = a.getEstimatedTotalWidth, f = a.getOffsetForColumnAndAlignment, v = a.getOffsetForRowAndAlignment, g = a.getRowHeight, S = a.getRowOffset, I = a.getRowStartIndexForOffset, F = a.getRowStopIndexForStartIndex, k = a.initInstanceProps, P = a.shouldResetStyleCacheOnItemSizeChange, W = a.validateProps;
  return e = /* @__PURE__ */ function(C) {
    Fe(O, C);
    function O(b) {
      var t;
      return t = C.call(this, b) || this, t._instanceProps = k(t.props, se(t)), t._resetIsScrollingTimeoutId = null, t._outerRef = void 0, t.state = {
        instance: se(t),
        isScrolling: !1,
        horizontalScrollDirection: "forward",
        scrollLeft: typeof t.props.initialScrollLeft == "number" ? t.props.initialScrollLeft : 0,
        scrollTop: typeof t.props.initialScrollTop == "number" ? t.props.initialScrollTop : 0,
        scrollUpdateWasRequested: !1,
        verticalScrollDirection: "forward"
      }, t._callOnItemsRendered = void 0, t._callOnItemsRendered = ee(function(d, c, m, p, u, h, w, T) {
        return t.props.onItemsRendered({
          overscanColumnStartIndex: d,
          overscanColumnStopIndex: c,
          overscanRowStartIndex: m,
          overscanRowStopIndex: p,
          visibleColumnStartIndex: u,
          visibleColumnStopIndex: h,
          visibleRowStartIndex: w,
          visibleRowStopIndex: T
        });
      }), t._callOnScroll = void 0, t._callOnScroll = ee(function(d, c, m, p, u) {
        return t.props.onScroll({
          horizontalScrollDirection: m,
          scrollLeft: d,
          scrollTop: c,
          verticalScrollDirection: p,
          scrollUpdateWasRequested: u
        });
      }), t._getItemStyle = void 0, t._getItemStyle = function(d, c) {
        var m = t.props, p = m.columnWidth, u = m.direction, h = m.rowHeight, w = t._getItemStyleCache(P && p, P && u, P && h), T = d + ":" + c, R;
        if (w.hasOwnProperty(T))
          R = w[T];
        else {
          var y = r(t.props, c, t._instanceProps), x = u === "rtl";
          w[T] = R = {
            position: "absolute",
            left: x ? void 0 : y,
            right: x ? y : void 0,
            top: S(t.props, d, t._instanceProps),
            height: g(t.props, d, t._instanceProps),
            width: o(t.props, c, t._instanceProps)
          };
        }
        return R;
      }, t._getItemStyleCache = void 0, t._getItemStyleCache = ee(function(d, c, m) {
        return {};
      }), t._onScroll = function(d) {
        var c = d.currentTarget, m = c.clientHeight, p = c.clientWidth, u = c.scrollLeft, h = c.scrollTop, w = c.scrollHeight, T = c.scrollWidth;
        t.setState(function(R) {
          if (R.scrollLeft === u && R.scrollTop === h)
            return null;
          var y = t.props.direction, x = u;
          if (y === "rtl")
            switch (fe()) {
              case "negative":
                x = -u;
                break;
              case "positive-descending":
                x = T - p - u;
                break;
            }
          x = Math.max(0, Math.min(x, T - p));
          var E = Math.max(0, Math.min(h, w - m));
          return {
            isScrolling: !0,
            horizontalScrollDirection: R.scrollLeft < u ? "forward" : "backward",
            scrollLeft: x,
            scrollTop: E,
            verticalScrollDirection: R.scrollTop < h ? "forward" : "backward",
            scrollUpdateWasRequested: !1
          };
        }, t._resetIsScrollingDebounced);
      }, t._outerRefSetter = function(d) {
        var c = t.props.outerRef;
        t._outerRef = d, typeof c == "function" ? c(d) : c != null && typeof c == "object" && c.hasOwnProperty("current") && (c.current = d);
      }, t._resetIsScrollingDebounced = function() {
        t._resetIsScrollingTimeoutId !== null && de(t._resetIsScrollingTimeoutId), t._resetIsScrollingTimeoutId = He(t._resetIsScrolling, Ve);
      }, t._resetIsScrolling = function() {
        t._resetIsScrollingTimeoutId = null, t.setState({
          isScrolling: !1
        }, function() {
          t._getItemStyleCache(-1);
        });
      }, t;
    }
    O.getDerivedStateFromProps = function(t, d) {
      return qe(t, d), W(t), null;
    };
    var M = O.prototype;
    return M.scrollTo = function(t) {
      var d = t.scrollLeft, c = t.scrollTop;
      d !== void 0 && (d = Math.max(0, d)), c !== void 0 && (c = Math.max(0, c)), this.setState(function(m) {
        return d === void 0 && (d = m.scrollLeft), c === void 0 && (c = m.scrollTop), m.scrollLeft === d && m.scrollTop === c ? null : {
          horizontalScrollDirection: m.scrollLeft < d ? "forward" : "backward",
          scrollLeft: d,
          scrollTop: c,
          scrollUpdateWasRequested: !0,
          verticalScrollDirection: m.scrollTop < c ? "forward" : "backward"
        };
      }, this._resetIsScrollingDebounced);
    }, M.scrollToItem = function(t) {
      var d = t.align, c = d === void 0 ? "auto" : d, m = t.columnIndex, p = t.rowIndex, u = this.props, h = u.columnCount, w = u.height, T = u.rowCount, R = u.width, y = this.state, x = y.scrollLeft, E = y.scrollTop, A = Ue();
      m !== void 0 && (m = Math.max(0, Math.min(m, h - 1))), p !== void 0 && (p = Math.max(0, Math.min(p, T - 1)));
      var _ = i(this.props, this._instanceProps), z = s(this.props, this._instanceProps), U = z > R ? A : 0, V = _ > w ? A : 0;
      this.scrollTo({
        scrollLeft: m !== void 0 ? f(this.props, m, c, x, this._instanceProps, V) : x,
        scrollTop: p !== void 0 ? v(this.props, p, c, E, this._instanceProps, U) : E
      });
    }, M.componentDidMount = function() {
      var t = this.props, d = t.initialScrollLeft, c = t.initialScrollTop;
      if (this._outerRef != null) {
        var m = this._outerRef;
        typeof d == "number" && (m.scrollLeft = d), typeof c == "number" && (m.scrollTop = c);
      }
      this._callPropsCallbacks();
    }, M.componentDidUpdate = function() {
      var t = this.props.direction, d = this.state, c = d.scrollLeft, m = d.scrollTop, p = d.scrollUpdateWasRequested;
      if (p && this._outerRef != null) {
        var u = this._outerRef;
        if (t === "rtl")
          switch (fe()) {
            case "negative":
              u.scrollLeft = -c;
              break;
            case "positive-ascending":
              u.scrollLeft = c;
              break;
            default:
              var h = u.clientWidth, w = u.scrollWidth;
              u.scrollLeft = w - h - c;
              break;
          }
        else
          u.scrollLeft = Math.max(0, c);
        u.scrollTop = Math.max(0, m);
      }
      this._callPropsCallbacks();
    }, M.componentWillUnmount = function() {
      this._resetIsScrollingTimeoutId !== null && de(this._resetIsScrollingTimeoutId);
    }, M.render = function() {
      var t = this.props, d = t.children, c = t.className, m = t.columnCount, p = t.direction, u = t.height, h = t.innerRef, w = t.innerElementType, T = t.innerTagName, R = t.itemData, y = t.itemKey, x = y === void 0 ? $e : y, E = t.outerElementType, A = t.outerTagName, _ = t.rowCount, z = t.style, U = t.useIsScrolling, V = t.width, q = this.state.isScrolling, G = this._getHorizontalRangeToRender(), Q = G[0], be = G[1], oe = this._getVerticalRangeToRender(), Te = oe[0], Re = oe[1], ae = [];
      if (m > 0 && _)
        for (var $ = Te; $ <= Re; $++)
          for (var j = Q; j <= be; j++)
            ae.push(X(d, {
              columnIndex: j,
              data: R,
              isScrolling: U ? q : void 0,
              key: x({
                columnIndex: j,
                data: R,
                rowIndex: $
              }),
              rowIndex: $,
              style: this._getItemStyle($, j)
            }));
      var ye = i(this.props, this._instanceProps), Me = s(this.props, this._instanceProps);
      return X(E || A || "div", {
        className: c,
        onScroll: this._onScroll,
        ref: this._outerRefSetter,
        style: re({
          position: "relative",
          height: u,
          width: V,
          overflow: "auto",
          WebkitOverflowScrolling: "touch",
          willChange: "transform",
          direction: p
        }, z)
      }, X(w || T || "div", {
        children: ae,
        ref: h,
        style: {
          height: ye,
          pointerEvents: q ? "none" : void 0,
          width: Me
        }
      }));
    }, M._callPropsCallbacks = function() {
      var t = this.props, d = t.columnCount, c = t.onItemsRendered, m = t.onScroll, p = t.rowCount;
      if (typeof c == "function" && d > 0 && p > 0) {
        var u = this._getHorizontalRangeToRender(), h = u[0], w = u[1], T = u[2], R = u[3], y = this._getVerticalRangeToRender(), x = y[0], E = y[1], A = y[2], _ = y[3];
        this._callOnItemsRendered(h, w, x, E, T, R, A, _);
      }
      if (typeof m == "function") {
        var z = this.state, U = z.horizontalScrollDirection, V = z.scrollLeft, q = z.scrollTop, G = z.scrollUpdateWasRequested, Q = z.verticalScrollDirection;
        this._callOnScroll(V, q, U, Q, G);
      }
    }, M._getHorizontalRangeToRender = function() {
      var t = this.props, d = t.columnCount, c = t.overscanColumnCount, m = t.overscanColumnsCount, p = t.overscanCount, u = t.rowCount, h = this.state, w = h.horizontalScrollDirection, T = h.isScrolling, R = h.scrollLeft, y = c || m || p || 1;
      if (d === 0 || u === 0)
        return [0, 0, 0, 0];
      var x = n(this.props, R, this._instanceProps), E = l(this.props, x, R, this._instanceProps), A = !T || w === "backward" ? Math.max(1, y) : 1, _ = !T || w === "forward" ? Math.max(1, y) : 1;
      return [Math.max(0, x - A), Math.max(0, Math.min(d - 1, E + _)), x, E];
    }, M._getVerticalRangeToRender = function() {
      var t = this.props, d = t.columnCount, c = t.overscanCount, m = t.overscanRowCount, p = t.overscanRowsCount, u = t.rowCount, h = this.state, w = h.isScrolling, T = h.verticalScrollDirection, R = h.scrollTop, y = m || p || c || 1;
      if (d === 0 || u === 0)
        return [0, 0, 0, 0];
      var x = I(this.props, R, this._instanceProps), E = F(this.props, x, R, this._instanceProps), A = !w || T === "backward" ? Math.max(1, y) : 1, _ = !w || T === "forward" ? Math.max(1, y) : 1;
      return [Math.max(0, x - A), Math.max(0, Math.min(u - 1, E + _)), x, E];
    }, O;
  }(Ee), e.defaultProps = {
    direction: "ltr",
    itemData: void 0,
    useIsScrolling: !1
  }, e;
}
var qe = function(e, r) {
  var n = e.children, l = e.direction, o = e.height, i = e.innerTagName, s = e.outerTagName, f = e.overscanColumnsCount, v = e.overscanCount, g = e.overscanRowsCount, S = e.width, I = r.instance;
  if (process.env.NODE_ENV !== "production") {
    if (typeof v == "number" && K && !K.has(I) && (K.add(I), console.warn("The overscanCount prop has been deprecated. Please use the overscanColumnCount and overscanRowCount props instead.")), (typeof f == "number" || typeof g == "number") && Z && !Z.has(I) && (Z.add(I), console.warn("The overscanColumnsCount and overscanRowsCount props have been deprecated. Please use the overscanColumnCount and overscanRowCount props instead.")), (i != null || s != null) && J && !J.has(I) && (J.add(I), console.warn("The innerTagName and outerTagName props have been deprecated. Please use the innerElementType and outerElementType props instead.")), n == null)
      throw Error('An invalid "children" prop has been specified. Value should be a React component. ' + ('"' + (n === null ? "null" : typeof n) + '" was specified.'));
    switch (l) {
      case "ltr":
      case "rtl":
        break;
      default:
        throw Error('An invalid "direction" prop has been specified. Value should be either "ltr" or "rtl". ' + ('"' + l + '" was specified.'));
    }
    if (typeof S != "number")
      throw Error('An invalid "width" prop has been specified. Grids must specify a number for width. ' + ('"' + (S === null ? "null" : typeof S) + '" was specified.'));
    if (typeof o != "number")
      throw Error('An invalid "height" prop has been specified. Grids must specify a number for height. ' + ('"' + (o === null ? "null" : typeof o) + '" was specified.'));
  }
}, me = 50, Ie = function(e, r) {
  var n = e.rowCount, l = r.rowMetadataMap, o = r.estimatedRowHeight, i = r.lastMeasuredRowIndex, s = 0;
  if (i >= n && (i = n - 1), i >= 0) {
    var f = l[i];
    s = f.offset + f.size;
  }
  var v = n - i - 1, g = v * o;
  return s + g;
}, Ce = function(e, r) {
  var n = e.columnCount, l = r.columnMetadataMap, o = r.estimatedColumnWidth, i = r.lastMeasuredColumnIndex, s = 0;
  if (i >= n && (i = n - 1), i >= 0) {
    var f = l[i];
    s = f.offset + f.size;
  }
  var v = n - i - 1, g = v * o;
  return s + g;
}, L = function(e, r, n, l) {
  var o, i, s;
  if (e === "column" ? (o = l.columnMetadataMap, i = r.columnWidth, s = l.lastMeasuredColumnIndex) : (o = l.rowMetadataMap, i = r.rowHeight, s = l.lastMeasuredRowIndex), n > s) {
    var f = 0;
    if (s >= 0) {
      var v = o[s];
      f = v.offset + v.size;
    }
    for (var g = s + 1; g <= n; g++) {
      var S = i(g);
      o[g] = {
        offset: f,
        size: S
      }, f += S;
    }
    e === "column" ? l.lastMeasuredColumnIndex = n : l.lastMeasuredRowIndex = n;
  }
  return o[n];
}, he = function(e, r, n, l) {
  var o, i;
  e === "column" ? (o = n.columnMetadataMap, i = n.lastMeasuredColumnIndex) : (o = n.rowMetadataMap, i = n.lastMeasuredRowIndex);
  var s = i > 0 ? o[i].offset : 0;
  return s >= l ? xe(e, r, n, i, 0, l) : Ge(e, r, n, Math.max(0, i), l);
}, xe = function(e, r, n, l, o, i) {
  for (; o <= l; ) {
    var s = o + Math.floor((l - o) / 2), f = L(e, r, s, n).offset;
    if (f === i)
      return s;
    f < i ? o = s + 1 : f > i && (l = s - 1);
  }
  return o > 0 ? o - 1 : 0;
}, Ge = function(e, r, n, l, o) {
  for (var i = e === "column" ? r.columnCount : r.rowCount, s = 1; l < i && L(e, r, l, n).offset < o; )
    l += s, s *= 2;
  return xe(e, r, n, Math.min(l, i - 1), Math.floor(l / 2), o);
}, pe = function(e, r, n, l, o, i, s) {
  var f = e === "column" ? r.width : r.height, v = L(e, r, n, i), g = e === "column" ? Ce(r, i) : Ie(r, i), S = Math.max(0, Math.min(g - f, v.offset)), I = Math.max(0, v.offset - f + s + v.size);
  switch (l === "smart" && (o >= I - f && o <= S + f ? l = "auto" : l = "center"), l) {
    case "start":
      return S;
    case "end":
      return I;
    case "center":
      return Math.round(I + (S - I) / 2);
    case "auto":
    default:
      return o >= I && o <= S ? o : I > S || o < I ? I : S;
  }
}, Be = /* @__PURE__ */ je({
  getColumnOffset: function(e, r, n) {
    return L("column", e, r, n).offset;
  },
  getColumnStartIndexForOffset: function(e, r, n) {
    return he("column", e, n, r);
  },
  getColumnStopIndexForStartIndex: function(e, r, n, l) {
    for (var o = e.columnCount, i = e.width, s = L("column", e, r, l), f = n + i, v = s.offset + s.size, g = r; g < o - 1 && v < f; )
      g++, v += L("column", e, g, l).size;
    return g;
  },
  getColumnWidth: function(e, r, n) {
    return n.columnMetadataMap[r].size;
  },
  getEstimatedTotalHeight: Ie,
  getEstimatedTotalWidth: Ce,
  getOffsetForColumnAndAlignment: function(e, r, n, l, o, i) {
    return pe("column", e, r, n, l, o, i);
  },
  getOffsetForRowAndAlignment: function(e, r, n, l, o, i) {
    return pe("row", e, r, n, l, o, i);
  },
  getRowOffset: function(e, r, n) {
    return L("row", e, r, n).offset;
  },
  getRowHeight: function(e, r, n) {
    return n.rowMetadataMap[r].size;
  },
  getRowStartIndexForOffset: function(e, r, n) {
    return he("row", e, n, r);
  },
  getRowStopIndexForStartIndex: function(e, r, n, l) {
    for (var o = e.rowCount, i = e.height, s = L("row", e, r, l), f = n + i, v = s.offset + s.size, g = r; g < o - 1 && v < f; )
      g++, v += L("row", e, g, l).size;
    return g;
  },
  initInstanceProps: function(e, r) {
    var n = e, l = n.estimatedColumnWidth, o = n.estimatedRowHeight, i = {
      columnMetadataMap: {},
      estimatedColumnWidth: l || me,
      estimatedRowHeight: o || me,
      lastMeasuredColumnIndex: -1,
      lastMeasuredRowIndex: -1,
      rowMetadataMap: {}
    };
    return r.resetAfterColumnIndex = function(s, f) {
      f === void 0 && (f = !0), r.resetAfterIndices({
        columnIndex: s,
        shouldForceUpdate: f
      });
    }, r.resetAfterRowIndex = function(s, f) {
      f === void 0 && (f = !0), r.resetAfterIndices({
        rowIndex: s,
        shouldForceUpdate: f
      });
    }, r.resetAfterIndices = function(s) {
      var f = s.columnIndex, v = s.rowIndex, g = s.shouldForceUpdate, S = g === void 0 ? !0 : g;
      typeof f == "number" && (i.lastMeasuredColumnIndex = Math.min(i.lastMeasuredColumnIndex, f - 1)), typeof v == "number" && (i.lastMeasuredRowIndex = Math.min(i.lastMeasuredRowIndex, v - 1)), r._getItemStyleCache(-1), S && r.forceUpdate();
    }, i;
  },
  shouldResetStyleCacheOnItemSizeChange: !1,
  validateProps: function(e) {
    var r = e.columnWidth, n = e.rowHeight;
    if (process.env.NODE_ENV !== "production") {
      if (typeof r != "function")
        throw Error('An invalid "columnWidth" prop has been specified. Value should be a function. ' + ('"' + (r === null ? "null" : typeof r) + '" was specified.'));
      if (typeof n != "function")
        throw Error('An invalid "rowHeight" prop has been specified. Value should be a function. ' + ('"' + (n === null ? "null" : typeof n) + '" was specified.'));
    }
  }
});
process.env.NODE_ENV;
function Ke(a, e, r) {
  var n = this, l = N(null), o = N(0), i = N(null), s = N([]), f = N(), v = N(), g = N(a), S = N(!0);
  g.current = a;
  var I = typeof window < "u", F = !e && e !== 0 && I;
  if (typeof a != "function")
    throw new TypeError("Expected a function");
  e = +e || 0;
  var k = !!(r = r || {}).leading, P = !("trailing" in r) || !!r.trailing, W = "maxWait" in r, C = "debounceOnServer" in r && !!r.debounceOnServer, O = W ? Math.max(+r.maxWait || 0, e) : null;
  ve(function() {
    return S.current = !0, function() {
      S.current = !1;
    };
  }, []);
  var M = ge(function() {
    var b = function(u) {
      var h = s.current, w = f.current;
      return s.current = f.current = null, o.current = u, v.current = g.current.apply(w, h);
    }, t = function(u, h) {
      F && cancelAnimationFrame(i.current), i.current = F ? requestAnimationFrame(u) : setTimeout(u, h);
    }, d = function(u) {
      if (!S.current)
        return !1;
      var h = u - l.current;
      return !l.current || h >= e || h < 0 || W && u - o.current >= O;
    }, c = function(u) {
      return i.current = null, P && s.current ? b(u) : (s.current = f.current = null, v.current);
    }, m = function u() {
      var h = Date.now();
      if (d(h))
        return c(h);
      if (S.current) {
        var w = e - (h - l.current), T = W ? Math.min(w, O - (h - o.current)) : w;
        t(u, T);
      }
    }, p = function() {
      if (I || C) {
        var u = Date.now(), h = d(u);
        if (s.current = [].slice.call(arguments), f.current = n, l.current = u, h) {
          if (!i.current && S.current)
            return o.current = l.current, t(m, e), k ? b(l.current) : v.current;
          if (W)
            return t(m, e), b(l.current);
        }
        return i.current || t(m, e), v.current;
      }
    };
    return p.cancel = function() {
      i.current && (F ? cancelAnimationFrame(i.current) : clearTimeout(i.current)), o.current = 0, s.current = l.current = f.current = i.current = null;
    }, p.isPending = function() {
      return !!i.current;
    }, p.flush = function() {
      return i.current ? c(Date.now()) : v.current;
    }, p;
  }, [k, W, e, O, P, F, I, C]);
  return M;
}
const Ze = ({
  rowHeight: a = 66,
  pagination: e,
  includeDefaultSorter: r = !0,
  ...n
}, l) => {
  const [o, i] = le({
    width: 0,
    height: 0
  }), s = N(), [f, v] = le(1);
  We(l, () => ({
    resetPagination: () => {
      v(1);
    }
  }));
  const g = B(() => {
    var C;
    (C = s.current) == null || C.resetAfterIndices({
      rowIndex: 0,
      columnIndex: 0,
      shouldForceUpdate: !0
    });
  }, []);
  ve(() => g);
  const S = B(() => {
    v(f + 1), e == null || e.onPaginationChange({
      offset: f * e.pageSize,
      pageSize: e.pageSize
    });
  }, [f, e]), I = Ke(S, 150), F = B((C, { scrollbarSize: O, onScroll: M }) => {
    const b = C.length * 54;
    return (
      // @ts-ignore
      n.columns && o.width ? /* @__PURE__ */ D(
        Be,
        {
          ref: s,
          className: "virtual-grid",
          columnCount: n.columns.length,
          columnWidth: (t) => b > Number(o.height ?? 0) && t === n.columns.length - 1 ? Number(n.columns[t].width) - O - 1 : Number(n.columns[t].width),
          height: Number(o.height) ?? 0,
          rowCount: C.length,
          rowHeight: () => a,
          onItemsRendered: (t) => {
            t.visibleRowStopIndex === C.length - 1 && I();
          },
          onScroll: ({ scrollLeft: t }) => {
            M({ scrollLeft: t });
          },
          width: o.width,
          children: ({
            columnIndex: t,
            rowIndex: d,
            style: c
          }) => {
            var h;
            const m = n.columns[t], p = C[d], u = Y.isArray(m.dataIndex) ? (h = p[m.dataIndex[0]]) == null ? void 0 : h[m.dataIndex[1]] : p[m.dataIndex];
            return /* @__PURE__ */ D(
              "div",
              {
                className: Le("virtual-table-cell", {
                  "virtual-table-cell-line-odd": d % 2 === 0,
                  "virtual-table-cell-line-even": d % 2 === 1,
                  // @ts-ignore
                  "virtual-table-cell-last": t === n.columns.length - 1
                }),
                style: {
                  ...c,
                  ...n.columns[t].style,
                  maxWidth: c.width,
                  padding: 8
                },
                children: /* @__PURE__ */ D(
                  Je,
                  {
                    $linecount: a < 40 ? 1 : 2,
                    children: m.render ? m.render(u, p, t) : /* @__PURE__ */ D(ie, { children: u })
                  }
                )
              }
            );
          }
        }
      ) : /* @__PURE__ */ D(ie, {})
    );
  }, [I, n.columns, a, o.height, o.width]), k = B((C, O) => {
    let M = C;
    return O.forEach((b) => {
      M = M[b];
    }), M;
  }, []), P = ge(() => r && n.columns ? n.columns.map((C) => ({
    ...C,
    sorter: {
      compare: (O, M) => {
        if (!C.dataIndex)
          return 0;
        const b = Y.isArray(C.dataIndex) ? C.dataIndex : [C.dataIndex], t = k(O, b), d = k(M, b);
        return String(t).localeCompare(String(d));
      }
    }
  })) : n.columns, [r, n.columns, k]), W = N();
  return _e(W, o, (C, O) => {
    (o.width !== C || o.height !== O - 37) && i({ width: C, height: O - 37 });
  }), /* @__PURE__ */ D("div", { style: { minHeight: 0, height: "100%" }, ref: W, children: /* @__PURE__ */ D(
    Qe,
    {
      ...Y.omit(n, "ref", "pagination", "columns"),
      tableLayout: "fixed",
      scroll: { y: o.height, x: 0 },
      pagination: !1,
      columns: P,
      components: {
        body: F
      }
    }
  ) });
}, at = Oe.forwardRef(Ze), Je = we.div`
  display: -webkit-box;
  max-width: calc(100%);
  min-width: calc(90%);
    -webkit-line-clamp: ${(a) => a.$linecount};
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;

  p {
    display: -webkit-box;
    max-width: calc(100%);
      -webkit-line-clamp: ${(a) => a.$linecount};
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`, Qe = we(Ae)`

  &&& {
    .ant-table-thead > tr > th {
      border-radius: 0;
      border: none;
    }

    thead {
      background-color: var(--main-background-color) !important;
    }

    .ant-table-thead > tr > th {
      background-color: transparent;
    }

    .ant-table-cell-scrollbar {
      box-shadow: none;
    }
    th, td {
      padding: 8px;
      height: 100%;
    }

    .virtual-table-cell {
      overflow: hidden;
      word-break: break-word;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    }

    .virtual-table-cell-line {
      &-odd {
        background-color: var(--row-odd);
      }

      &-even {
        background-color: var(--row-even);
      }
    }
  }

`;
export {
  at as default
};
//# sourceMappingURL=DataSource.Table.js.map
